import { array, Decoder, field, number, string, succeed } from 'jsonous';
import { resourceDecoder } from '../Resource/Decoders';
import { EventPoll, EventPollResource, EventPollsResource } from './Types';

const eventPollDecoder: Decoder<EventPoll> = succeed({})
  .assign('id', field('id', number))
  .assign('name', field('name', string))
  .assign('url', field('url', string));

const eventPollResourceDcoder: Decoder<EventPollResource> = resourceDecoder(eventPollDecoder);

export const eventPollsResourceDecoder: Decoder<EventPollsResource> = resourceDecoder(
  array(eventPollResourceDcoder),
);
